function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ErrorBoundary } from "./";
/**
 * HOC to wrap a component with an ErrorBoundary from mwa-logger
 * @param Component The Component to be wrapperd
 * @param onError Error handler function, called when an error is caught, use it with Logger
 * @param fallback Fallback UI to be rendered when an error is caught
 */ export function withErrorBoundary(Component, param) {
    var onError = param.onError, fallback = param.fallback;
    return function WrappedComponent(props) {
        return /*#__PURE__*/ _jsx(ErrorBoundary, {
            onError: onError,
            fallback: fallback,
            children: /*#__PURE__*/ _jsx(Component, _extends({}, props))
        });
    };
}
